<template>
  <div class="loading flexcenter">
    <transition>
      <div class="load flexcenter">
        <div>画面を読み込んでいます...</div>
        <div class="progress"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import common from '@/mixin/common'

export default {
  name: 'loading',
  mixins: [
    common,
  ],
  mounted: function() {
    this.log("Loading start mounted")
    // Safariのブラウザ縮小時の高さ調整
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1){
      this.fixtHeightForSafariFullWindow()
    }

    this.setBodyStylePosition(true)
  },
  beforeDestroy: function() {
    this.setBodyStylePosition(false)
  }
}
</script>

<style lang="scss">
@import 'src/assets/style/modal';
</style>



// WEBPACK FOOTER //
// Loading.vue?03992c36